import React from 'react';
import { useTranslation } from 'react-i18next';

interface RestoreStatusBadgeProps {
  status: 'pending' | 'in_progress' | 'awaiting_validation' | 'completed' | 'failed' | 'cancelled';
  className?: string;
}

const RestoreStatusBadge: React.FC<RestoreStatusBadgeProps> = ({ status, className = '' }) => {
  const { t } = (useTranslation as any)('backups');
  const getStatusConfig = () => {
    switch (status) {
      case 'pending':
        return {
          label: t('restoreStatus.pending'),
          bgColor: 'bg-surface-3',
          textColor: 'text-text-primary',
          dotColor: 'bg-gray-500'
        };
      case 'in_progress':
        return {
          label: t('restoreStatus.inProgress'),
          bgColor: 'bg-blue-500/12',
          textColor: 'text-blue-400',
          dotColor: 'bg-blue-500'
        };
      case 'awaiting_validation':
        return {
          label: t('restoreStatus.awaitingValidation'),
          bgColor: 'bg-blue-500/12',
          textColor: 'text-blue-400',
          dotColor: 'bg-blue-500'
        };
      case 'completed':
        return {
          label: t('restoreStatus.completed'),
          bgColor: 'bg-green-500/12',
          textColor: 'text-green-400',
          dotColor: 'bg-green-500'
        };
      case 'failed':
        return {
          label: t('restoreStatus.failed'),
          bgColor: 'bg-red-500/12',
          textColor: 'text-red-400',
          dotColor: 'bg-red-500'
        };
      case 'cancelled':
        return {
          label: t('restoreStatus.cancelled'),
          bgColor: 'bg-surface-3',
          textColor: 'text-text-primary',
          dotColor: 'bg-gray-500'
        };
      default:
        return {
          label: status,
          bgColor: 'bg-surface-3',
          textColor: 'text-text-primary',
          dotColor: 'bg-gray-500'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dotColor}`} />
      {config.label}
    </span>
  );
};

export default RestoreStatusBadge;
